// DualRangeSlider.jsx
import React from 'react';
import './range.scss';

const DualRangeSlider = ({ minYear, maxYear, setMinYear, setMaxYear }) => {
  const minLimit = 2011;
  const maxLimit = 2025;

  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxYear - 1);
    setMinYear(value);
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minYear + 1);
    setMaxYear(value);
  };

  const getTrackStyle = () => {
    const percent1 = ((minYear - minLimit) / (maxLimit - minLimit)) * 100;
    const percent2 = ((maxYear - minLimit) / (maxLimit - minLimit)) * 100;

    return {
      background: `linear-gradient(to right, #dee2e6 ${percent1}%,
        rgb(90,130,249) ${percent1}%,
        rgb(90,130,249) ${percent2}%,
        #dee2e6 ${percent2}%)`,
    };
  };

  return (
    <div className="range-wrapper">
      <label className="form-label mb-1">Year Range: {minYear} – {maxYear}</label>
      <div className="slider-container">
        <input
          type="range"
          min={minLimit}
          max={maxLimit}
          value={minYear}
          onChange={handleMinChange}
          className="thumb thumb-left"
        />
        <input
          type="range"
          min={minLimit}
          max={maxLimit}
          value={maxYear}
          onChange={handleMaxChange}
          className="thumb thumb-right"
        />
        <div className="slider-track" style={getTrackStyle()}></div>
      </div>
    </div>
  );
};

export default DualRangeSlider;
